import React, { useEffect, useState } from "react";
import { transformTodoContent, updateTodos } from "../../../function/common";
import axios from "axios";
import { MemoContainer } from "../../../styled/scheduler";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { FaCheck } from "react-icons/fa6";
import { useLocation } from "react-router";

const Memo = ({ eventInfo, todos, setTodos, setActive }) => {
  const { pathname } = useLocation();
  const user = useSelector((state) => state?.user?.data[0]);
  const { isDarkMode } = useSelector((state) => state.scheduler);

  useEffect(() => {
    getTodos();
  }, []);

  // 투두 조회
  const getTodos = async () => {
    const url = "/api/todo/by-schedule";
    const body = { scheduleNo: eventInfo.scheduleNo };
    const res = await axios.post(url, body);

    if (res.status === 200) {
      const todos = res.data.rtnModel;

      if (todos) {
        const updatedTodos = updateTodos(todos, eventInfo.memo);
        setTodos(updatedTodos);
      } else {
        setTodos([]);
      }
    }
  };

  const updateTodo = async (item) => {
    if (pathname.includes("share-report")) return;
    if (
      !user ||
      ![
        ...Object.keys(eventInfo.workerList || {}),
        String(eventInfo?.mberNo),
        String(eventInfo?.managerNo),
      ].includes(String(user.mberNo))
    ) {
      toast.error("참여자만 수정 가능합니다.");
      return;
    }

    const url = "/api/todo";
    const body = {
      ...item,
      checkedMberNo: user.mberNo,
      isCompleted: !item.isCompleted,
      mentions: item.mentions.map((mention) => mention.mberNo),
    };

    const res = await axios.put(url, [body]);

    if (res.status === 200) {
      await getTodos();
    }
  };

  const memberNameMatch = (mberNo) => {
    if (eventInfo?.workerList && eventInfo?.workerList[mberNo]) {
      return eventInfo.workerList[mberNo];
    }
    if (eventInfo?.managerNo === mberNo) {
      return eventInfo.managerNm;
    }
    return "";
  };

  return (
    <MemoContainer className={`memo ${isDarkMode}`}>
      <ul>
        {todos.map((item) => (
          <li>
            {item.id && (
              <label>
                <input
                  type="checkbox"
                  checked={item.isCompleted}
                  onChange={() => updateTodo(item)}
                />
                <span className="checkmark"></span>
              </label>
            )}
            <span>{transformTodoContent(item.content)}</span>
            {(item.checkedMberNm || item.checkedAt) && (
              <div className="checkedInfo">
                <i>
                  <FaCheck />
                </i>
                <span>
                  {[
                    item.checkedAt && moment(item.checkedAt).format("YY-MM-DD HH:mm"),
                    item.checkedMberNm,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </span>
              </div>
            )}
            {item.mentions.length > 0 && (
              <div className="mentions">
                {item.mentions.map((mention) => (
                  <span>@{memberNameMatch(mention.mberNo)}</span>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </MemoContainer>
  );
};

export default Memo;
